<div class="d-flex flex-column h-100">
  <h1 class="font-28 fw-bold mb-3">{{ 'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.TITLE' | translate }}</h1>
  <p class="font-16" [innerHTML]="'PROCESSES.HOUSING_CERTIFICATE.POST_PAYMENT.SUBTITLE' | translate"></p>

  <div *ngIf="!pdfLoading" class="d-flex pt-5">
    <img class="imageAttestRender"  src="../assets/img/services/attestPostPayment.png" alt="attestation de logement Livinfrance">
    <div class=" mtbtn btnCustomise ps-3 w-100 gap-16 bg-white pb-lg-0 flex-column">
      <div class="flex-column">
        <div class="mb-4">
          <button class="btn w-100 fw-bold btn-border-primary text-primary" (click)="goToForm()" [ngClass]="isMobile ? 'py-2 1.2rem' : 'py-2'">
            <span class="material-icons me-1 va-sub" [ngClass]="isMobile ? 'font-24' : 'font-20'">border_color</span>
            {{ 'COMMON.EDIT' |translate }}
          </button>
        </div>

        <div>
          <button class="btn w-100 btn-primary fw-bold m-auto" (click)="download()" [ngClass]="isMobile ? 'py-2 1.2rem' : 'py-2'">
            <span class="v-middle spinner-border spinner-border-sm" role="status" *ngIf="pdfLoading">
              <span class="sr-only">Loading...</span>
            </span>
            <span *ngIf="!pdfLoading"><span class="material-icons me-1 va-sub" [ngClass]="isMobile ? 'font-24' : 'font-20'">get_app</span>{{ 'COMMON.DOWNLOAD' |translate }}</span>
          </button>
        </div>
    </div>
  </div>
  </div>
  <div class="flex-grow-1 mt-4 text-center w-100 mb-2" >
    <div class="spinner-border spinner-border-sm " role="status" *ngIf="pdfLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div class="pt-2">
    <app-faq-accordion [faqFields]="faqFields"></app-faq-accordion>
  </div>

</div>
